import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { Label } from '@primer/react';
import styled from 'styled-components';
import { truncateTextFromMiddle, isEnterOrSpacePressed } from '../../utils/functions.js';
import LTTooltip from '../LTTooltip/index.js';

var LabelWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: fit-content;\n"], ["\n  width: fit-content;\n"])));
/**
 * Tags component.
 * @param {!Object<string, string>} customStyle Style to be applied to the label.
 * @param {string} size
 * @param {string} text The text to be displayed.
 * @param {string} variant
 * @param {number} textLength
 */
var LTTag = function LTTag(_a) {
  var _b = _a.ariaHidden,
    ariaHidden = _b === void 0 ? false : _b,
    _c = _a.clickable,
    clickable = _c === void 0 ? false : _c,
    _d = _a.clickHandler,
    clickHandler = _d === void 0 ? function () {} : _d,
    _e = _a.customStyle,
    customStyle = _e === void 0 ? {} : _e,
    _f = _a.id,
    id = _f === void 0 ? undefined : _f,
    _g = _a.forwardRef,
    forwardRef = _g === void 0 ? null : _g,
    _h = _a.size,
    size = _h === void 0 ? LTTag.Size.SMALL : _h,
    _j = _a.text,
    text = _j === void 0 ? "" : _j,
    _k = _a.textLength,
    textLength = _k === void 0 ? 20 : _k,
    _l = _a.toolTipDirection,
    toolTipDirection = _l === void 0 ? LTTooltip.Direction.TOP : _l,
    _m = _a.hideTooltip,
    hideTooltip = _m === void 0 ? false : _m,
    _o = _a.variant,
    variant = _o === void 0 ? LTTag.Variant.BLUE_ACCENT : _o;
  var truncatedText = truncateTextFromMiddle(text, textLength);
  var onKeyDownHandler = function onKeyDownHandler(e) {
    if (isEnterOrSpacePressed(e)) {
      clickHandler(e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": ariaHidden
  }, /*#__PURE__*/React.createElement(LabelWrapper, {
    style: {
      width: "fit-content"
    }
  }, /*#__PURE__*/React.createElement(LTTooltip, {
    text: hideTooltip ? null : text,
    direction: toolTipDirection
  }, /*#__PURE__*/React.createElement(Label, {
    id: id,
    onClick: clickable ? clickHandler : undefined,
    onKeyDown: clickable ? function (e) {
      return onKeyDownHandler(e);
    } : undefined,
    role: clickable ? "button" : undefined,
    ref: forwardRef,
    sx: __assign(__assign({
      "&:focus-visible": {
        outlineColor: "#101010"
      }
    }, variant === LTTag.Variant.BLUE_ACCENT && {
      borderColor: "blueAccent.emphasis",
      color: "blueAccent.fg"
    }), customStyle),
    size: size,
    tabIndex: clickable ? 0 : undefined,
    variant: variant
  }, truncatedText))));
};
LTTag.Size = {
  LARGE: "large",
  SMALL: "small"
};
LTTag.Variant = {
  BLUE_ACCENT: "blueAccent",
  ATTENTION: "attention",
  DANGER: "danger",
  DONE: "done",
  DEFAULT: "default",
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SEVERE: "severe",
  SPONSORS: "sponsors",
  SUCCESS: "success"
};
var templateObject_1;

export { LTTag as default };
